import { Output, EventEmitter, Directive, HostListener, Input } from '@angular/core';

import { AgprComponentStyleEnum } from '../../../../Common/Basic/enums/social-analysis-types.enum';
import { CoreDialogService } from '../../services/dialog.service';



@Directive()
export abstract class AbstractDialogComponent {
    key: string;

    readonly agprComponentStyle = AgprComponentStyleEnum;

    @Input() public style: AgprComponentStyleEnum = AgprComponentStyleEnum.social;
    @Output() dialogClose: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        public coreDialogService: CoreDialogService,
        public dialogKey: string,
    ) {
        // By default, each type of dialog will only be allowed to have 1 instance open.
        // You can change this by giving each instance it's own key in the constructor, instead of all having the same key
        this.key = dialogKey;
    }

    @HostListener('window:keyup.escape', ['$event']) onKeyDown(e: KeyboardEvent) {
        const lastDialog = this.coreDialogService.getLastDialog();
        if (this.key === lastDialog?.instance.key) {
            this.closeDialog();
        }
    }

    public closeDialog(closeAction?: any) {
        this.coreDialogService.close(this.key);
        this.dialogClose.emit(closeAction);
    }
}
